// models
import ApiAuth from "../src/models/ApiAuth.js"
import Foobar from "../src/models/Foobar.js"



//////////////////
// WEBPACK FOOTER
// ./build/webpack.apollo.js
// module id = 456
// module chunks = 15